/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ProactiveChatNames } from '../../helpers/consts';
import { TContextProvider } from '../../../interfaces';
import ProactiveChatTrigger from './proactive-chat-trigger';

/**
 * SpecificPageTrigger class - proactive chat is triggered if current page is listed in config.proactiveOnSpecificPageList
 */
class SpecificPageTrigger extends ProactiveChatTrigger {
    public async validate(): Promise<boolean> {
        let isValid = false;
        if (this.props.config.proactiveOnSpecificPageList) {
            this.props.context.telemetry.debug(
                `[${SpecificPageTrigger.name}] Number of items in user-defined list of 'Specific Pages' was '${this.props.config.proactiveOnSpecificPageList?.length}'.`
            );
            for (let i = 0; i < (this.props.config.proactiveOnSpecificPageList?.length || 0); i++) {
                const specificPageTrimmed: string = this.props.config.proactiveOnSpecificPageList[i].trim();
                this.props.context.telemetry.debug(`[] Current location URL: ${window.location.href}.`);
                this.props.context.telemetry.debug(`[] Current item from user-defined list of 'Specific Page': ${specificPageTrimmed}.`);
                if (window.location.href.indexOf(specificPageTrimmed) > -1) {
                    isValid = true;
                    break;
                }
            }
        } else {
            this.props.context.telemetry.debug(`[Chat][${SpecificPageTrigger.name}] User-defined 'Specific Page' list was undefined.`);
        }
        this.props.context.telemetry.debug(`[Chat][${SpecificPageTrigger.name}] Validation returning '${isValid}'.`);
        return isValid;
    }

    public getContextProvider(): TContextProvider {
        return () => {
            return {
                ...this.context,
                eCommerceCustIsProactiveChat: 'True',
                eCommerceCustProactiveType: ProactiveChatNames.SpecificPage
            };
        };
    }

    public getMessage(): string {
        // @TODO: Add message processing if needed
        return this.props.config.proactiveOnSpecificPageMessage || this.props.config.proactiveDefaultMessage;
    }
}

export default SpecificPageTrigger;
